export function getLinkUrlByNominationType(nominationType) {
    switch (nominationType) {
        case 'DEFILE':
            return '/page/uchastnikam/scenic/defile';
        case 'DANCE':
            return '/page/uchastnikam/scenic/coverdance';
        case 'KARAOKE':
            return '/page/uchastnikam/scenic/karaoke';
        case 'SCENKA':
            return '/page/uchastnikam/scenic/scenes';
        case 'MASTER':
            return '/page/uchastnikam/masters';
        case 'ACCREDITATION':
            return '/page/uchastnikam/accred';
        case 'SPECIAL_PRIZE':
            return '/page/uchastnikam/scenic/specialprizes';
        case 'FAIR':
            return '/page/uchastnikam/fair';
        case 'FOOD_COURT':
            return '/page/uchastnikam/foodcourt';
        case 'AUTHORS_ALLEY':
            return '/page/uchastnikam/authorsalley';
        default:
            return null;
    }
}
